import React, { useEffect, useState } from 'react';
import './Newsletter.scss';
import firebase from '../../FirebaseConfig/firebase';
import Spinner from '../SpinnerComponent/Spinner';
import FB from 'firebase';
//import { FaArrowCircleRight } from 'react-icons/fa';

const Newsletter = () => {

    const [email, setEmail] = useState('');
    const [checkAdd, setCheckAdd] = useState(false);
    const [thankyou, setThankyou] = useState(false);

    const handleSubmit = (e) => {
        setCheckAdd(true);
        e.preventDefault();
        const userEmail = firebase.firestore().collection('subscribers');
        const addEmail = {
            email: email,
            date: FB.firestore.FieldValue.serverTimestamp()
        };

        userEmail.add(addEmail).then(() => {
            e.target.reset();
            setCheckAdd(false);
            setThankyou(true);
        }).catch(err => {
            console.log(err);
        });
    };


    return (
        <div className="col-md-12 row newsletter-body justify-content-center align-items-center" style={{ boxSizing: 'border-box', width: '100vw', overflow: 'hidden' }}>
            <div className="col-md-6  d-flex  justify-content-center book-container" data-aos="fade-right" style={{ boxSizing: 'border-box' }}>
                <div className="imgLoader"></div>

                <div className="container2 d-none d-md-block" style={{ boxSizing: 'border-box' }}>


                    <div className="book pl-5 pr-5">
                        <div className="gap"></div>
                        <div className="pages">
                            <div className="page"></div>
                            <div className="page"></div>
                            <div className="page"></div>
                            <div className="page"></div>
                            <div className="page"></div>
                            <div className="page"></div>
                        </div>
                        <div className="flips">
                            <div className="flip flip1">
                                <div className="flip flip2">
                                    <div className="flip flip3">
                                        <div className="flip flip4">
                                            <div className="flip flip5">
                                                <div className="flip flip6">
                                                    <div className="flip flip7"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div className="col-md-6 col-sm-12 px-5 justify-content-center newsletter-subscribe-section" style={{ boxSizing: 'border-box' }}>
                <h3 className="text-description-newsletter" data-aos="fade-down-left">Subscribe to Leo Club of <br />Colombo Monarch <span>Newsletter</span></h3>
                <h6 className="text-align-center" data-aos="fade-down-left">Subscribe to our official Newsletter, Monarch Paragon to stay up to date! Get the latest information delivered straight to your inbox.</h6>
                <form onSubmit={handleSubmit} className="justify-content-center col-md-12 col-sm-12 pt-5 px-0">
                    <div className="justify-content-center row col-md-12 col-sm-12 px-0" data-aos="zoom-in-up">
                        <div className="form__group field col-lg-6 col-md-10 col-sm-12 d-flex justify-content-center">
                            <input type="input" className="form__field newsletter-subscribe-input px-0" placeholder="Name" name="name" id='name' required onChange={(e) => {
                                setEmail(e.target.value);
                            }} />
                            <label for="name" className="form__label ">Email address</label>
                        </div>
                        <div className="pt-3 pl-5 justify-content-center">
                            <button type="submit" className="btn-subscribe " >Subscribe</button><br />

                            {
                                checkAdd && <p><Spinner /></p>
                            }
                            {
                                thankyou && <p>Thank you for subscribing our NewsLetter</p>
                            }
                        </div>

                    </div>


                </form>

            </div>
            <div data-aos="zoom-in-up" className="prev-monarch-paragons">
                <a href="https://drive.google.com/drive/folders/1SL6bO3AOBgojikhVKCZ-cHYo7fCjngA1?usp=sharing" >
                    <button type="submit" className="btn btn-success btn-lg btn-block" >View Monarch Paragon Previous Edtions  </button>
                </a>

            </div>
        </div>

    );
};

export default Newsletter;